import React from "react";
import SelectOrganization from "./SelectOrganization";
import ConnectFIRS from "./ConnectFIRS";
import EditConnectFIRS from "./EditFIRSConnection";
import BusinessInformation from "./BusinessInformation";
import { useMutation, useQuery } from "@tanstack/react-query";
import integrationService from "../../../service/integrationService";
import moment from "moment";
import SelectTaxes from "./SelectTaxes";
import IntegrationCredentials from "./IntegrationCredentials";
import errorHandler from "../../../utils/errorHandler";

const AddNewIntegration = ({ isOpen, onClose, integrationData, refetch }) => {
  const [currentStep, setCurrentStep] = React.useState(1);
  const [organization, setOrganizaiton] = React.useState(null);
  const [credentials, setCredentials] = React.useState(null);

  const handleClose = () => {
    onClose();
    setCurrentStep(1);
    setCredentials(null);
  };

  const handleCloseCredentials = () => {
    setCredentials(null);
    refetch?.();
    handleClose();
  };

  const organizationId = integrationData?.organizationId ?? organization?.id;

  const integrationIterfaceQuery = useQuery({
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
    queryKey: ["integration-interface", organization],
    queryFn: () => integrationService.getIntegrationsInterface({ interface: "FIRS", organizationId: organizationId }),
  });

  const interfacesQuery = useQuery({
    enabled: isOpen,
    refetchOnWindowFocus: false,
    queryKey: ["interfaces"],
    queryFn: () => integrationService.getInterfaces({}),
  });

  const addInterfaceMutation = useMutation({
    mutationFn: (data) => integrationService.addIntegration(...data),
    onSuccess({ data }) {
      integrationIterfaceQuery.refetch();
      const created = data?.data;
      if (created?.credentials) {
        setCurrentStep(0);
        setCredentials(created.credentials);
        return;
      }
      setCurrentStep((prev) => prev + 1);
    },
    onError: ({ response }) => errorHandler(response),
  });

  const handleSelectOrganization = (organization) => {
    addInterfaceMutation.mutate([{ interfaceId: firsInterface?.id }, organization?.id]);
    setOrganizaiton(organization);
  };

  const integration = integrationIterfaceQuery?.data?.data?.data;
  const interfaces = interfacesQuery?.data?.data?.data;
  const firsInterface = interfaces?.find((item) => item?.alias === "FIRS");

  console.log("integrationData", integration);
  React.useEffect(() => {
    if (!integrationData) return;
    if (integrationData?.status === "ACTIVE") {
      setCurrentStep(0);
      return;
    }
    if (integrationData?.status === "ONBOARDING" && integrationData?.onboarding?.currentStep === 1) {
      setCurrentStep(2);
      return;
    }
    if (
      (integrationData?.status === "ONBOARDING" && integrationData?.onboarding?.currentStep === 2) ||
      !moment(integrationData?.onboarding?.steps[1]?.completedAt ?? null).isValid()
    ) {
      setCurrentStep(3);
      return;
    }
    if (
      integrationData?.status === "ONBOARDING" &&
      integrationData?.onboarding?.currentStep === 3 &&
      !moment(integrationData?.onboarding?.steps[2]?.completedAt ?? null).isValid()
    ) {
      setCurrentStep(4);
      return;
    }
  }, [integrationData, isOpen, organization]);

  const defaultIntegration = integrationData ?? integration;

  return (
    <React.Fragment>
      <SelectOrganization
        isOpen={isOpen}
        onClose={handleClose}
        currentStep={currentStep}
        organization={organization}
        isLoading={addInterfaceMutation.isPending}
        handleSelectOrganization={handleSelectOrganization}
      />
      <ConnectFIRS
        isOpen={isOpen}
        onClose={handleClose}
        id={defaultIntegration?.id}
        integration={defaultIntegration}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
      <EditConnectFIRS
        isOpen={isOpen}
        onClose={handleClose}
        id={defaultIntegration?.id}
        integration={defaultIntegration}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        refetch={refetch}
      />
      <BusinessInformation
        onClose={handleClose}
        id={defaultIntegration?.id}
        integration={defaultIntegration}
        isOpen={isOpen}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        organization={organization}
      />
      <SelectTaxes
        isOpen={isOpen}
        onClose={handleClose}
        currentStep={currentStep}
        id={defaultIntegration?.id}
        integration={defaultIntegration}
        setCurrentStep={setCurrentStep}
        refetch={refetch}
      />
      <IntegrationCredentials credentials={credentials} onClose={handleCloseCredentials} />
    </React.Fragment>
  );
};

export default AddNewIntegration;
